import { notifyParent } from 'mailup-react-helpers'
import {
  Button,
  Grid,
  GridCell,
  Modal,
  ModalBody,
  ModalFoot,
  ModalHead,
  TEXT_VARIANT_BOLD,
  Text
} from 'mailup-web-components'
import { modalFilterDetailState } from 'Pages/Task/recoil/state/modals'
import { useIntl } from 'react-intl'
import { useRecoilValue, useResetRecoilState } from 'recoil'

export const ModalFilterDetails = () => {
  const intl = useIntl()
  const { show, id, type, name, description } = useRecoilValue(
    modalFilterDetailState
  )

  const resetModal = useResetRecoilState(modalFilterDetailState)

  const handleClickConfirm = () => {
    resetModal()

    notifyParent('redirectMainFrame', [
      `filters_app_redirector.aspx?r=${encodeURIComponent(`/filters/form/${id}`)}`
    ])
  }

  return (
    <Modal
      show={show}
      onClose={resetModal}
      className='b-modal--filter-details'
      data-mu-test='modal-filter-details'
    >
      <ModalHead
        title={intl.formatMessage({
          id: 'Load.SearchRecipients.EditFilterFilterTitle'
        })}
      />

      <ModalBody>
        <Grid cols={4}>
          <GridCell span={1}>
            <Text variant={TEXT_VARIANT_BOLD}>
              {intl.formatMessage({
                id: 'Load.SearchRecipients.EditFilterFilterType'
              })}
            </Text>
          </GridCell>
          <GridCell span={3}>
            <p>{type}</p>
          </GridCell>
          <GridCell span={1}>
            <Text variant={TEXT_VARIANT_BOLD}>
              {intl.formatMessage({
                id: 'Load.SearchRecipients.EditFilterFilterName'
              })}
            </Text>
          </GridCell>
          <GridCell span={3}>
            <p>
              {id} - {name}
            </p>
          </GridCell>
          <GridCell span={1}>
            <Text variant={TEXT_VARIANT_BOLD}>
              {intl.formatMessage({
                id: 'Load.SearchRecipients.EditFilterFilterConditions'
              })}
            </Text>
          </GridCell>
          <GridCell span={3}>
            <p>{description}</p>
          </GridCell>
        </Grid>
      </ModalBody>

      <ModalFoot>
        <Button kind='secondary' onClick={resetModal}>
          {intl.formatMessage({
            id: 'Load.SearchRecipients.EditFilterCloseButton'
          })}
        </Button>
        <Button kind='secondary' onClick={handleClickConfirm}>
          {intl.formatMessage({
            id: 'Load.SearchRecipients.EditFilterEditButton'
          })}
        </Button>
      </ModalFoot>
    </Modal>
  )
}
